export default "__VITE_ASSET__CHCyihLq__"